export default "__VITE_ASSET__849cd480__"